import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Gift } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { api } from "@/lib/api";

export const Promo = () => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api
      .get("/promo")
      .then((res) => setPromo(res.data))
      .catch(() => {});
  }, []);

  if (!promo || !promo.active) return null;
  const left = promo.remaining;

  return (
    <section data-testid="promo-section" className="relative overflow-hidden bg-gold text-ink">
      <div className="mx-auto flex max-w-[1440px] flex-col items-center gap-8 px-6 py-14 text-center lg:flex-row lg:justify-between lg:px-12 lg:text-left">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center gap-5 lg:flex-row lg:items-center"
        >
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-ink text-gold">
            <Gift size={22} />
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.35em]">Start-Aktion — nur für kurze Zeit</p>
            <h2 className="mt-2 font-serif text-3xl font-light leading-tight tracking-tight sm:text-4xl" data-testid="promo-title">
              Die ersten 3 sichern sich ein <span className="italic">Gratis-Shooting.</span>
            </h2>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="flex flex-col items-center gap-5 lg:items-end"
        >
          {left > 0 ? (
            <div className="flex items-center gap-3" data-testid="promo-counter">
              <span className="relative flex h-3 w-3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ink opacity-50" />
                <span className="relative inline-flex h-3 w-3 rounded-full bg-ink" />
              </span>
              <p className="font-mono text-[11px] uppercase tracking-[0.25em]">
                Noch <span className="font-serif text-2xl normal-case tracking-normal">{left}</span> von {promo.total} Plätzen frei
              </p>
            </div>
          ) : (
            <p className="font-mono text-[11px] uppercase tracking-[0.25em]" data-testid="promo-soldout">
              Alle {promo.total} Gratis-Plätze sind vergeben
            </p>
          )}
          {left > 0 && (
            <button
              onClick={() => scrollToId("#termine")}
              data-testid="promo-cta-button"
              className="group flex items-center gap-3 rounded-full bg-ink px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-gold transition-transform hover:scale-[1.03]"
            >
              Jetzt Platz sichern
              <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};
